<div class="av text-center">
    <h4>Do you want to make it not available?</h4>
    <div class="btns mt-3">
        <button class="btn btn-danger mr-2" (click)="setItemNotAvailable()">Yes</button>
        <button class="btn btn-primary" (click)="closeDialog()">No</button>
    </div>
</div>